import {useState} from "react";
import {SortDirection} from "../types/SortDirection";

export default function useSorting() {
    const [queryString, setQueryString] = useState<string | null>(null);
    const [currentSort, setCurrentSort] = useState<Record<string, SortDirection>>({});

    function sortBy(path: string, direction: SortDirection) {
        switch (direction) {
            case SortDirection.ASCENDING:
                setQueryString(path)
                setCurrentSort({[path]: direction})
                break

            case SortDirection.DESCENDING:
                setQueryString(`-${path}`)
                setCurrentSort({[path]: direction})
                break

            default:
                setQueryString(null)
                setCurrentSort({})
        }
    }

    return {currentSort, queryString, sortBy}
}